// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1GmY4","title":"Header_title__e80J6","side":"Header_side__1vz9y"};